import React, { Component } from 'react';
import SelectField from 'material-ui/SelectField';

class FormSelectField extends Component {
    handleChange = (event, key, value) => {
        const { name, onChange } = this.props;

        onChange(name, value);
    };

    render() {
        const { onChange, name, required, ...props } = this.props;

        return <SelectField onChange={this.handleChange} {...props} />;
    }
}

export default FormSelectField;



// WEBPACK FOOTER //
// ./src/UI/FormSelectField.js